'use client';

import React from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PhProvider } from 'posthog-js/react';
import { isEnvDev } from 'utils';
import { useCookieConsent } from './cookie-consent';

type PostHogProviderProps = {
  children: React.ReactNode;
  isEU: boolean;
};

export function RootPostHog({ children, isEU }: PostHogProviderProps) {
  const { isAccepted } = useCookieConsent();
  React.useEffect(() => {
    if (isEnvDev || location.hostname.endsWith('.vercel.app')) {
      return;
    }
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: '/api/_ingest',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only',
      disable_session_recording: true,
      persistence: isEU && isAccepted ? 'localStorage+cookie' : 'localStorage',
    });
    if (Math.random() < 0.2 && isAppleDevice()) {
      posthog.startSessionRecording();
    }
  }, [isEU, isAccepted]);
  if (isEnvDev) {
    return <>{children}</>;
  }
  return <PhProvider client={posthog}>{children}</PhProvider>;
}

function isAppleDevice() {
  try {
    const userAgent = navigator.userAgent.toLowerCase();

    return /mac|iphone|ipad|ipod/.test(userAgent);
  } catch {
    return false;
  }
}
